import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ExceptionsComponent } from './exceptions.component';


@NgModule({
  declarations: [
    ExceptionsComponent,
    //ExceptionsFileComponent,
    //ExceptionsTextComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxJsonViewerModule,
    DropzoneModule
  ],
  exports: [
    ExceptionsComponent
  ]
})
export class ExceptionsModule { }